export default "__VITE_ASSET__zLdR5Zdl__"